export default __webpack_public_path__ + "static/media/C888.144131dc.webp";